// extracted by mini-css-extract-plugin
module.exports = {"container":"stats-content_container__MDnfX"};